import { Action, LOGOUT, SET_USERINFO, State } from "./types";

export function logout() {
    sessionStorage.clear();
    localStorage.clear();
    return {
        type: LOGOUT
    }
}

export function setUserInfoState(userInfo: State): Action {
    return {
        type: SET_USERINFO,
        payload: userInfo
    }
}
